// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filed_line[data-v-58d30479] {\n  position: relative;\n}\n.filed_line[data-v-58d30479]::after {\n  position: absolute;\n  box-sizing: border-box;\n  content: \" \";\n  pointer-events: none;\n  right: 0.426667rem;\n  bottom: 0;\n  left: 0.426667rem;\n  border-bottom: 0.026667rem solid #ebedf0;\n  transform: scaleY(0.5);\n}", ""]);
// Exports
module.exports = exports;
